import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FeatherModule} from 'angular-feather';
import {Eye, EyeOff} from 'angular-feather/icons';

const icons = {
    Eye,
    EyeOff
};

@NgModule({
  declarations: [],
    imports: [
        FeatherModule.pick(icons),
        CommonModule
    ],
    exports: [
        FeatherModule
    ]
})
export class IconsModule { }
